<template>
    <div>
        <div class="white-box md:mb-5 pb-12 md:pb-6">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isLoadingData" />
                <div v-else>
                    <ul class="text-tip border-b border-gray-100 pb-2.5 md:mb-5">
                        <li>應補收自動墊繳保費本息僅供參考用，若保費未墊繳至保費應繳費相當日，則本次仍須再補收至保費應繳費相當日之天數保費，實際應補收之金額將以Email或簡訊通知。</li>
                    </ul>
                    <div class="border-b border-gray-200 pb-2.5 mb-2.5 md:mb-5">
                        <h4 class="mb-2.5">
                            目前的自動墊繳保費本息
                        </h4>
                        <div class="w-full xs:text-lg">
                            <div class="flex justify-between table-space max-w-[25rem]">
                                <div>自動墊繳保費本金</div>
                                <div>{{ addComma(showData.autoPremLoanCapital) }}</div>
                            </div>
                            <hr class="border-gray-100 border-dashed">
                            <div class="flex justify-between table-space max-w-[25rem]">
                                <div>自動墊繳保費利息</div>
                                <div>{{ addComma(showData.autoPremLoanInterest) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="pb-2.5">
                        <h4 class="mb-2.5">
                            請選擇欲申請之項目
                        </h4>
                        <div>
                            <div class="mb-2.5">
                                <Radio
                                    v-model:checkedValue="userData.repayType"
                                    value="1"
                                    name="item"
                                    text="全部償清"
                                    @input="resetAmount"
                                />
                            </div>
                            <div>
                                <Radio
                                    v-model:checkedValue="userData.repayType"
                                    value="2"
                                    name="item"
                                    text="部分償清"
                                />
                            </div>
                            <div
                                class="pl-5 md:pl-6 mt-1"
                                :class="{'text-gray-00':userData.repayType !== '2'}"
                            >
                                <div class="flex">
                                    <div class="xs:text-lg leading-[2.75rem] xs:leading-[3rem]">
                                        新台幣
                                    </div>
                                    <div class="mx-2">
                                        <input
                                            v-model="userData.premAmount"
                                            :disabled="userData.repayType !== '2'"
                                            type="text"
                                            class="input-base  max-w-[11.5rem] md:max-w-[12.5rem]"
                                            placeholder="輸入欲償還金額"
                                            maxlength="7"
                                            inputmode="numeric"
                                            autocomplete="off"
                                            @input="validateAmount"
                                        >
                                        <p class="text-error text-right">
                                            {{ userData.errorMessage.premAmount }}
                                        </p>
                                    </div>
                                    <div class="xs:text-lg leading-[2.75rem] xs:leading-[3rem]">
                                        元
                                    </div>
                                </div>
                                <div class="w-full mt-1">
                                    (最低應清償金額 新台幣{{ addComma(showData.premAmountMin) }}元)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
    <Bottombar>
        <template #right>
            <ButtonNextService
                v-model:isSubmitOk="isSubmitOk"
                :disabled="!userData.repayType"
                @click="validGoNext"
            />
        </template>
    </Bottombar>
    <Loading :isLoading="isLoading" />
</template>

<script>
import { reactive, toRefs, inject, computed } from 'vue';
import { getInfoC2, submitC2 } from '@/apis/C2';
import { addComma } from '@/utils/number/addComma';
import { intMinMax } from '@/utils/rules/customRules';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Skeletons from './Skeletons.vue';
import dialogContnet from '@/json/dialogContent.js';
import Loading from '@/components/Loading.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Radio from '@/components/radios/Radio.vue';
import _ from 'lodash';

export default {
    components: {
        Radio,
        Bottombar,
        ButtonNextService,
        Loading,
        Skeletons
    },
    setup() {
        const $vfm = inject('$vfm');
        const route = useRoute();
        const store = useStore();
        const { code } = route.meta;

        const state = reactive({
            isLoadingData: false,
            isLoading: false,
            isSubmitOk: false
        });
        const data = reactive({
            showData: {},
            userData: {
                repayType: '',
                premAmount: 0, // TODO:最大值是?
                errorMessage: {
                    premAmount: ''
                }
            }
        });
        const result = computed(() => store.state.services.changeItemsResult[code]);
        const getData = () => {
            state.isLoadingData = true;
            getInfoC2().then(res => {
                state.isLoadingData = false;
                data.showData = res.data;
            }).catch(() => {
                state.isLoadingData = false;
            });
        };
        /** 返回修改 */
        if (!result.value) {
            getData();
        } else {
            const { showData, userData } = result.value;
            data.showData = _.cloneDeep(showData);
            data.userData = _.cloneDeep(userData);
        }

        const resetAmount = () => {
            data.userData.premAmount = 0;
            data.userData.errorMessage.premAmount = '';
        };

        const validateAmount = (e) => {
            const { val, errorMessage } = intMinMax({
                value: e.target.value,
                minNum: data.showData.premAmountMin,
                minMaxMsg: '請大於最低應清償金額'
            });
            data.userData.errorMessage.premAmount = errorMessage;
            e.target.value = val;
        };

        const validGoNext = () => {
            const { repayType, premAmount } = data.userData;
            if (repayType === '2' && !premAmount) data.userData.errorMessage.premAmount = '請輸入部分償清金額';
            const hasError = data.userData.errorMessage.premAmount !== '';
            if (hasError) {
                modalShow(dialogContnet.validateMsg);
            } else {
                submit();
            }
        };

        const submit = () => {
            state.isLoading = true;
            const { repayType, premAmount } = data.userData;
            const returnData = {
                repayType: repayType,
                premAmount: premAmount
            };
            submitC2(returnData).then(() => {
                const storeData = {};
                storeData.showData = data.showData;
                storeData.userData = data.userData;
                store.dispatch('services/setChangeItemsResult', { code, value: storeData });
                state.isSubmitOk = true;
            }).catch(() => {
                state.isLoading = false;
            });
        };

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            addComma,
            resetAmount,
            validateAmount,
            validGoNext
        };
    }
};
</script>
<style lang="scss" scoped>
.table-space {
    @apply py-2.5 first:pt-0 last:pb-0;
}
</style>
